"use client";

import { I18nextProvider } from "react-i18next";
import i18n from "../i18n/config";
import { usePreferences } from "./contexts/PreferencesContext";
import { useEffect } from "react";
import { ReCaptchaProvider } from "./providers/ReCaptchaProvider";

function I18nProvider({ children }: { children: React.ReactNode }) {
  const { language } = usePreferences();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <I18nProvider>
      <ReCaptchaProvider>{children}</ReCaptchaProvider>
    </I18nProvider>
  );
}
